import Enumerable from "linq";
import { IObjectsControllable } from "../../../../../../../documaker/domain/format/objects";
import { IXElementContentsObjectBean, IXElementContentsObjectRelationalBean } from "../../../beans";
import { RelationTranslator } from "./RelationTranslator";
import { ILinkedObjectTranslatable } from "./ILinkedObjectTranslatable";

export class ObjectTargetsTranslator<T> {
  constructor(action: string, private readonly target: ILinkedObjectTranslatable<T>) {
    this.relationalItems = new RelationTranslator(action);
  }

  from(bean: IXElementContentsObjectBean): IObjectsControllable<T> {
    return this.relationalItems.from(
      bean,
      is => ({
        targets: Enumerable.from(is)
          .select(i => this.target.from(i))
          .where(i => !!i)  // オブジェクト参照変換が無効値を返した場合は間引く.
          .toArray(),
      }),
      {
        targets: [],
      });
  }

  to(object: IObjectsControllable<T>): IXElementContentsObjectRelationalBean {
    return this.relationalItems.to(
      Enumerable.from(object.targets)
        .select(r => this.target.to(r))
        .where(i => !!i)  // オブジェクト参照変換が無効値を返した場合は間引く.
        .toArray());
  }

  private readonly relationalItems: RelationTranslator;
}
